import { IBaseService } from '@pit/core';
import { BehaviorSubject } from 'rxjs';

export enum ConnectionType {

    Unknown = 1,
    None = 2,
    WiFi = 4,
    Cellular = 8,
    Ethernet = 16

}

export interface IPinItTrackFrontendDeviceService extends IBaseService {

    connectionType?: ConnectionType;
    connectionType$?: BehaviorSubject<ConnectionType>;
    isConnectedToNetwork?: boolean;
    isConnectedToNetwork$?: BehaviorSubject<boolean>;

    endNetworkMonitorAsync?: () => Promise<void>;
    startNetworkMonitorAsync?: () => Promise<void>;

}
